<template>
  <div
    v-if="item && item.isShow === 1 && modeList && modeList.length > 0"
    class="mode9-box relative"
    :class="[IsMobile ? 'IsMobile' : '']"
  >
    <el-skeleton :loading="skeletonLoading" animated :throttle="0">
      <template slot="template">
        <el-skeleton-item variant="image" style="width: 100%; height: 50px" />
      </template>
      <template>
        <div ref="mode9NavWrap" :class="['mode9-nav-header', showStyle === 2 ? 'style-2' : '']">
          <div
            v-for="(v, i) in modeList"
            :key="i"
            ref="mode9NavItem"
            class="mode9-nav"
            :class="i === navIndex ? 'cur-nav' : ''"
            v-exposure="{ eid: `101_18_${curindex}_${i}` }"
            :data-id="`101_18_${curindex}_${i}`"
            @click="handelSelect(v, i)"
          >
            <!-- :src="
          $utils.returnImgUrl(
            i === navIndex ? v.langInfoObj[lang]?.selectedIcon : v.langInfoObj[lang]?.unselectedIcon
          )
        " -->
            <img
              :class="[IsMobile ? 'IsMobile' : '']"
              :src="
                $utils.returnImgUrl(
                  i === navIndex
                    ? $utils.lang_data(lang, v, 'langInfoObj')?.selectedIcon
                    : $utils.lang_data(lang, v, 'langInfoObj')?.unselectedIcon
                )
              "
              alt
            />
            <div class="mode9-nav-title">{{ $utils.lang_data(lang, v, "langInfoObj")?.navName }}</div>
          </div>
        </div>
      </template>
    </el-skeleton>

    <!-- 多款游戏查询 厂商 标签  玩法 查询-->
    <div
      v-if="curObj.jump?.type === 'Jump_TYPE_MULTIPLE_GAME'"
      :style="`margin-bottom: ${$px2rem(30)}; margin-top: ${$px2rem(10)}`"
    >
      <!-- <el-row :gutter="10">
        <el-col :span="IsMobile ? 8 : 4">
          <el-select
            v-model="gameForm.brandGroupSid"
            clearable
            :placeholder="$t('Datalang.Betrecord_TITLE_provider')"
            style="width: 100%"
            size="medium"
            @change="getGamelistFun(1)"
            popper-class="mode9-select"
          >
            <el-option v-for="item in brandGroupList" :key="item.sid" :label="item.name" :value="item.sid"></el-option>
          </el-select>
        </el-col>
        <el-col :span="IsMobile ? 8 : 4">
          <el-select
            v-model="gameForm.gameTagSid"
            clearable
            :placeholder="$t('Datalang.HomePage_tag')"
            style="width: 100%"
            size="medium"
            @change="getGamelistFun(1)"
            popper-class="mode9-select"
          >
            <el-option v-for="item in tagList" :key="item.sid" :label="item.name" :value="item.sid"></el-option>
          </el-select>
        </el-col>
        <el-col :span="IsMobile ? 8 : 4">
          <el-select
            v-model="gameForm.gamePlayTypeSid"
            clearable
            :placeholder="$t('Datalang.HomePage_playmode')"
            style="width: 100%"
            size="medium"
            @change="getGamelistFun(1)"
            popper-class="mode9-select"
          >
            <el-option v-for="item in playList" :key="item.sid" :label="item.name" :value="item.sid"></el-option>
          </el-select>
        </el-col>
        <el-col :span="IsMobile ? 24 : 8" :offset="IsMobile ? 0 : 4">
          <el-input
            class="search-input"
            v-model="gameForm.gameGroupName"
            style="width: 100%"
            size="medium"
            prefix-icon="el-icon-search"
            @input="keyWordFun"
          ></el-input>
        </el-col>
      </el-row> -->
    </div>

    <div v-if="curObj.jump?.type === 'Jump_TYPE_MULTIPLE_GAME' && pcList && pcList.length > 0">
      <div class="content-wrap" ref="contentWrap">
        <div class="p-hot-box">
          <template v-for="(item, i) in list">
            <div
              class="img-box"
              v-if="hidegd(item)"
              :key="'pc_' + i"
              :class="{ 'mr-0': IsMobile ? (i + 1) % 3 === 0 : (i + 1) % 6 === 0 }"
              :style="{ animationDelay: getAnimationDelay(i) }"
            >
              <gameItem :item="item" :key="'game_' + i" />
            </div>
          </template>
          <div class="more-btn-box" v-if="!IsMobile && isMore">
            <div class="more-btn" @click="moreFun">{{ $t("Datalang.HomePage_BTM_loadmore") }}</div>
          </div>
          <div style="width: 100%" v-if="IsMobile && isMore">
            <mode9More :isMore="isMore" @moreFun="moreFun"></mode9More>
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="curObj.jump?.type === 'Jump_TYPE_MULTIPLE_GAME' && list.length == 0 && zhanwutype === true"
      class="zanwu"
    >
      <img :src="zanwu" alt />
      <div>{{ $t("Datalang.Invite_TITLE_nodatanow") }}</div>
    </div>
  </div>
</template>

<script>
import mode9 from "@/lobby_common/mixins_views/homeModule/mode9.js";
export default {
  mixins: [mode9],
};
</script>

<style lang="scss" scoped>
.mode9-box.IsMobile ::v-deep .el-row {
  margin-left: 0px !important;
  margin-right: 0px !important;
}
.IsMobile ::v-deep .mode9-nav-header {
  flex-wrap: nowrap;
  overflow-x: auto;
  &.style-2 {
    // padding: 7px 7px 0;
  }
  &::-webkit-scrollbar {
    display: none;
  }

  .mode9-nav {
    padding: 0 10px;
    height: 35px;
    min-width: 40px;
    line-height: 35px;
    margin-right: 10px;
    border-radius: var(--radius-200);
    background: var(--button-400);
    font-size: 12px;
  }
}

::v-deep .mode9-nav-header {
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
  overflow-x: auto;
  &.style-2 {
    background: var(--background-1600);
    // padding: 5px 7px 0;
    border-radius: var(--radius-100);
  }

  &::-webkit-scrollbar {
    display: block;
  }

  .mode9-nav {
    position: relative;
    flex-shrink: 0;
    min-width: 80px;
    height: 40px;
    line-height: 40px;
    padding: 0 12px;
    margin-right: 10px;
    margin-bottom: 8px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    flex-direction: row;
    color: var(--font-color-600);
    background: var(--button-400);
    border-radius: var(--radius-100);
    box-shadow: var(--boxShadow-400);
    transition: background ease 0.3s;
    font-size: 14px;
    font-weight: bold;
    &:hover {
      background: var(--button-401);
    }
    img {
      margin-right: 8px;
      width: 14px;
    }

    img.IsMobile {
      margin-right: 6px;
      width: 12px;
      height: auto;
    }

    .mode9-nav-title {
      white-space: nowrap;
    }
    &.cur-nav {
      // border-bottom: 4px solid $highlight-color-200;
      background: var(--button-500);
      // border: solid 2px $highlight-color-400;
      color: var(--font-color-600);
      box-shadow: var(--boxShadow-500);
      .mode9-nav-title {
        color: var(--font-color-700);
      }
    }
  }
  .mode9-nav:hover ~ .mode9-nav::before {
    left: 0;
  }
}
</style>
<style lang="scss" scoped>
.mode9-box {
  margin-top: 20px;
  // margin-bottom: 20px;
  // background-color: $background-800;
  // border-radius: 10px;
  // padding: 10px;
  &.IsMobile {
    margin-top: 18px;
    background: none;
    padding: 0px 8px;
  }
}
.IsMobile .search-input {
  margin-top: 10px;
}

.IsMobile .p-hot-box {
  padding: 0 5px;
  box-sizing: border-box;

  .img-box {
    width: 30%;
    margin-right: 5%;
  }
}

.p-hot-box {
  width: 100%;
  overflow: hidden;

  .img-box {
    position: relative;
    display: inline-block;
    width: 15%;
    margin: 0 auto;
    margin-right: 2%;
    margin-bottom: 16px;
    text-align: center;
    cursor: pointer;

    &.h5-box {
      width: 30%;
      margin-right: 5%;

      & > .txt {
        font-size: 14px;
        height: 42px;
        line-height: 42px;
      }

      &.more-box {
        position: relative;

        & > .txts {
          position: absolute;
          top: 35%;
          left: 50%;
          transform: translate(-50%, -50%);
        }
      }
    }

    ::v-deep .el-image__inner {
      transition: 0.5s;

      &:hover {
        transform: scale(1.4);
        transition: all 1s ease 0s;
        -webkit-transform: scale(1.4);
        -webkit-transform: all 1s ease 0s;
      }
    }

    .relative {
      img {
        max-width: 100%;
        border-radius: 20px;
        -webkit-border-radius: 20px;
        -moz-border-radius: 20px;
        -ms-border-radius: 20px;
        -o-border-radius: 20px;
      }
    }

    &.mr-0 {
      margin-right: 0;
    }

    &:last-child {
      margin-right: 0;
    }

    .txt {
      width: 100%;
      height: 42px;
      line-height: 42px;
      font-size: 12px;
      overflow: hidden;
      white-space: nowrap;
      /*不换行*/
      text-overflow: ellipsis;
      /*超出部分文字以...显示*/
    }
  }
}

.more-btn-box {
  width: 100%;
  padding: 10px 0;
  text-align: center;
  .more-btn {
    // width: 150px;
    display: inline-block;
    padding: 0 15px;
    height: 32px;
    line-height: 32px;
    background: var(--background-1100);
    margin: 0 auto;
    border-radius: var(--radius-200);
    margin-bottom: 16px;
    text-align: center;
    font-size: 14px;
    cursor: pointer;
    color: var(--font-color-200);
  }
}

.zanwu {
  width: 100%;
  margin: 0 auto;
  text-align: center;

  // height: 100px;
  img {
    display: inline-block;
    width: 100px;
    height: 97px;
  }
}
.img-box {
  -webkit-animation: ping 0.4s cubic-bezier(0, 0, 0.2, 1) forwards;
  animation: ping 0.4s cubic-bezier(0, 0, 0.2, 1) forwards;
  opacity: 0;
}
@keyframes ping {
  50% {
    -webkit-transform: scale(0.1);
    -ms-transform: scale(0.1);
    transform: scale(0.1);
    opacity: 0;
  }
  100% {
    -webkit-transform: scale(1);
    -ms-transform: scale(1);
    transform: scale(1);
    opacity: 1;
  }
}
</style>
